/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_TitleInputs */

const fr_rooms_title = /** @type {(inputs: Rooms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurations de chambres`)
};

const en_rooms_title = /** @type {(inputs: Rooms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room configurations`)
};

/**
* | output |
* | --- |
* | "Room configurations" |
*
* @param {Rooms_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_title = /** @type {((inputs?: Rooms_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_title(inputs)
	return en_rooms_title(inputs)
});